@if (participants.length === 1) {
  <a
    class="nav-link dropdown-toggle cursor-pointer no-caret"
    role="button"
    (click)="viewParticipant(participants[0].participant, participants[0].type)">
    <span class="avatar avatar-sm mr-2" [ngClass]="'avatar-' + participants[0].colorSchema">
      <span>{{ participants[0].initials | uppercase }}</span>
    </span>
    <span class="customer-name"
      >{{ participants[0].salutationTypeId | resourceById | async }} {{ participants[0].name }}</span
    >
  </a>
} @else if (participants.length > 1) {
  <div ngbDropdown>
    <a
      aria-haspopup="true"
      class="nav-link cursor-pointer no-caret d-flex"
      role="button"
      ngbDropdownToggle
      appKeyboardClickable>
      @for (participant of participants; track participant) {
        <span class="avatar avatar-sm mr-2" [ngClass]="'avatar-' + participant.colorSchema">
          <span>{{ participant.initials | uppercase }}</span>
        </span>
      }
      <div class="d-inline-flex flex-column pr-2 justify-content-center">
        <span class="customer-name">{{ participants[participants.length - 1].name }}</span>
        <span class="customer-name customer-name-partner small text-secondary text-white">
          @if (participants.length === 2) {
            {{ participants[0].salutationTypeId | resourceById | async }}
            {{ participants[0].name }}
          } @else if (participants.length === 3) {
            {{
              ((participants[1].salutationTypeId | resourceById | async) + ' ' + participants[1].name).trim() +
                ' | ' +
                ((participants[0].salutationTypeId | resourceById | async) + ' ' + participants[0].name).trim()
            }}
          }
        </span>
      </div>
      <div class="dropdown-toggler">
        <i class="material-icons">keyboard_arrow_down</i>
      </div>
      <div ngbDropdownMenu class="project-participants-list">
        @for (participant of participants; track participant) {
          <button
            ngbDropdownItem
            class="pl-3 pl-lg-4 pr-2"
            (click)="viewParticipant(participant.participant, participant.type)">
            <span class="avatar avatar-sm mr-2" [ngClass]="'avatar-' + participant.colorSchema">
              <span>{{ participant.initials | uppercase }}</span>
            </span>
            <span class="customer-name overflow-ellipsis mw-100 pr-5">{{ participant.name }}</span>
          </button>
        }
      </div>
    </a>
  </div>
}
